import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../layout/inputWrapper";
import { useFieldArray, useForm } from "react-hook-form";
import { Button, Table, TableContainer } from "@mui/material";
import { yesOrNo } from "../../../TCPForms/data";
import { useTranslation } from "react-i18next";
import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/HighlightOff";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ButtonWrapper from "../../components/Button";
const CompletionChecklist = ({ formData, isEmployee, isApproved, handleTabChange, isCitizen }) => {
  console.log("insidechecklistcompletion", formData);
  const { t } = useTranslation();
  const identifyLayoutCase = (data) => {
    if (
      data?.descriptionOfLand?.activityProposed === "Plotted Development" ||
      data?.descriptionOfLand?.activityProposed === "Plotted Development - Affordable"
    ) {
      return true;
    } else return false;
  };

  console.log("EMPLOYYEE1212", isEmployee, isCitizen);
  const isLayoutCase = identifyLayoutCase(formData);
  const emptyLandUseRow = {
    category: "",
    approvedArea: "",
    approvedPercent: "",
    developedArea: "",
    developedPercent: "",
    deviationArea: "",
    deviationPercent: "",
  };
  const emptyFeatureRow = {
    feature: "",
    approvedNo: "",
    approvedArea: "",
    completionNo: "",
    completionArea: "",
  };

  const defaultLandUseRows = [
    {
      id: 1,
      category: "Residential",
      approvedArea: "",
      approvedPercent: "",
      developedArea: "",
      developedPercent: "",
      deviationArea: "",
      deviationPercent: "",
    },
    {
      id: 2,
      category: "Commercial",
      approvedArea: "",
      approvedPercent: "",
      developedArea: "",
      developedPercent: "",
      deviationArea: "",
      deviationPercent: "",
    },
    {
      id: 3,
      category: "Other",
      approvedArea: "",
      approvedPercent: "",
      developedArea: "",
      developedPercent: "",
      deviationArea: "",
      deviationPercent: "",
    },
    {
      id: 4,
      category: "Parks & Open Spaces",
      approvedArea: "",
      approvedPercent: "",
      developedArea: "",
      developedPercent: "",
      deviationArea: "",
      deviationPercent: "",
    },
    {
      id: 5,
      category: "Roads and Streets",
      approvedArea: "",
      approvedPercent: "",
      developedArea: "",
      developedPercent: "",
      deviationArea: "",
      deviationPercent: "",
    },
  ];
  const defaultFeatureRows = [
    { id: 1, feature: "Primary School", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 2, feature: "Higher Secondary School", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 3, feature: "Degree College", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 4, feature: "Dispensary", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 5, feature: "Hospital", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 6, feature: "Post Office", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 7, feature: "Community Centre", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 8, feature: "Police Station", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 9, feature: "Fire Station", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 10, feature: "Telephone Exchange", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 11, feature: "Bus Station", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 12, feature: "Taxi Rank", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 13, feature: "Public Facilities", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
    { id: 14, feature: "Other Facilities", approvedNo: "", approvedArea: "", completionNo: "", completionArea: "" },
  ];

  const defaultValues = {
    landUseDetails: formData?.completionChecklist?.landUseDetails || defaultLandUseRows,
    landInfo: {
      ...formData?.landInfo,
    },
    // completionChecklist: {
    //   facilitiesSetback: [
    //     {
    //       type: "Front Setback",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Rear Setback",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Side 1 Setback",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Side 2 Setback",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Plinth Height",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //   ],
    //   facilitiesBasement: [
    //     {
    //       type: "Basement Provided",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Basement Usage",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Basement Ventilation",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //     {
    //       type: "Basement Parking",
    //       asPerPlan: "",
    //       onSite: "",
    //       remarks: "",
    //     },
    //   ],
    // },

    completionChecklist: {
      facilitiesSetback: formData?.completionChecklist?.completionChecklist?.facilitiesSetback || [
        {
          type: "Front Setback",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Rear Setback",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Side 1 Setback",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Side 2 Setback",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Plinth Height",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
      ],

      facilitiesBasement: formData?.completionChecklist?.completionChecklist?.facilitiesBasement || [
        {
          type: "Basement Provided",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Basement Usage",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Basement Ventilation",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
        {
          type: "Basement Parking",
          asPerPlan: "",
          onSite: "",
          remarks: "",
        },
      ],
    },

    featureDetails: formData?.completionChecklist?.featureDetails || defaultFeatureRows,
    challanDetails: formData?.completionChecklist?.challanDetails || [
      {
        date: "",
        receiptNo: "",
        bankName: "",
        amount: "",
      },
    ],
    khasraDetails: formData?.descriptionOfLand?.khasraDetails || [{ district: "", tehsil: "", village: "", plotNo: "" }],
  };

  // const debounce = (fn, delay) => {
  //   let timer;
  //   return (...args) => {
  //     clearTimeout(timer);
  //     timer = setTimeout(() => {
  //       fn.apply(this, args);
  //     }, delay);
  //   };
  // };
  // const throttle = (fn, args) => {
  //   let last;

  //   return (...args) => {
  //     const now = Date.now();

  //     if (now - last > delay) {
  //       fn(...args);
  //     }
  //   };
  // };
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues });
  const landUseDetails = watch("landUseDetails");
  const featureDetails = watch("featureDetails");
  const addRow = () => {
    setValue("landUseDetails", [...landUseDetails, emptyLandUseRow]);
  };

  const removeRow = (index) => {
    if (index < 5) return; // first 5 rows fixed (cannot delete)
    const updated = landUseDetails.filter((_, i) => i !== index);
    setValue("landUseDetails", updated);
  };
  const addFeatureRow = () => {
    setValue("featureDetails", [...featureDetails, emptyFeatureRow]);
  };

  const removeFeatureRow = (index) => {
    if (index < 14) return; // first 14 rows fixed
    const updated = featureDetails.filter((_, i) => i !== index);
    setValue("featureDetails", updated);
  };
  const isDA = formData?.department === "DA";
  const inputWidth = 180;

  const checklist = formData?.landInfo?.checklistdata || {};
  const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const khasraDetails = !isSchemeType ? formData?.descriptionOfLand?.khasraDetails : [];
  const { fields: challanDetails, append: addPaymentDetail, remove: removePaymentDetail } = useFieldArray({
    control,
    name: "challanDetails",
  });
  const { fields: facilitiesSetback, append: addSetbackRow, remove: removeSetbackRow } = useFieldArray({
    control,
    name: "completionChecklist.facilitiesSetback",
  });
  const { fields: facilitiesBasement, append: addBasementRow, remove: removeBasementRow } = useFieldArray({
    control,
    name: "completionChecklist.facilitiesBasement",
  });
  const emptyPaymentRow = {
    date: "",
    receiptNo: "",
    bankName: "",
    amount: "",
  };
  const emptyBasementRow = {
    description: "",
    asPerPlan: "",
    onSite: "",
    remarks: "",
  };
  const emptySetbackRow = {
    description: "",
    asPerPlan: "",
    onSite: "",
    remarks: "",
  };
  console.log({ facilitiesSetback });

  const addBasementRows = () => {
    addSetbackRow({
      type: "Enter Description",
      asPerPlan: "",
      onSite: "",
      remarks: "",
    });
  };
  const addSetBackRows = () => {
    addSetbackRow({
      type: "Enter Description",
      asPerPlan: "",
      onSite: "",
      remarks: "",
    });
  };
  const onSubmit = (payload) => {
    const data = { ...formData, completionChecklist: { ...payload } };
    handleTabChange(5, data);
  };
  return (
    <form className="groupContainer2" onSubmit={handleSubmit(onSubmit)}>
      <div className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">{t("Applicant Details")}</h2>
        </div>
        <Container fluid className="formInputContainer common-app-form">
          <Row>
            <Col>
              <InputWrapper
                label={t("Name of the applicant")}
                control={control}
                placeholder={t("LABEL_ENTER_NAME")}
                name="landInfo.owners.[0].name"
                mandatory
                maxLength={15}
                defaultValue={formData?.landInfo?.owners?.[0]?.name}
                type="textInput"
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                  pattern: {
                    value: Digit.Utils.getPattern("Name"),
                    message: "Please enter only letters and spaces",
                  },
                }}
                disabled={isEmployee || isApproved || formData?.landInfo?.owners?.[0]?.name}
              />
            </Col>
            <Col>
              {" "}
              <InputWrapper
                control={control}
                label={t("LABEL_ADDRESS")}
                placeholder={t("LABEL_ENTER_ADDRESS")}
                name="landInfo.owners.[0].correspondenceAddress.address"
                defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                type="textInput"
                mandatory
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                  // pattern: {
                  //   value: Digit.Utils.getPattern("Address"),
                  //   message: "Please enter valid Address",
                  // },
                }}
                maxLength={50}
                disabled={isEmployee || isApproved || formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
              />
            </Col>
          </Row>
          {!isSchemeType ? (
            <fieldset className="fieldset-wrapper bg-white">
              {/* <legend style={{ fontWeight: "bold", fontSize: "1rem" }}>Land/Khasra Details</legend> */}
              <TableContainer className="table-container">
                <Table stickyHeader className="application-table landUserTable" border="1" cellPadding="8">
                  <thead
                    className="table-no-background"
                    style={{
                      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                      // background: "#f0f0f0"
                    }}
                  >
                    <tr>
                      <th style={{ width: "25%" }}>
                        {t("LABEL_DISTRICT")}
                        <span className="compulsoryField"> *</span>
                      </th>
                      <th style={{ width: "20%" }}>
                        {t("Tehsil")}
                        <span className="compulsoryField"> *</span>
                      </th>
                      <th style={{ width: "20%" }}>
                        Village<span className="compulsoryField"> *</span>
                      </th>
                      <th style={{ width: "25%" }}>
                        Plot No./Khasra No./Arazi No.<span className="compulsoryField"> *</span>
                      </th>
                      <th style={{ width: "10%" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {khasraDetails?.length > 0 &&
                      khasraDetails?.map((item, index) => {
                        // const selectedTehsil = khasraTehsils?.[index]?.tehsil;
                        // const selectedDistrict = khasraTehsils?.[index]?.district;
                        // const filteredVillages = isDA
                        //   ? filterVillagesData(
                        //       villagesData,
                        //       isDA ? formData?.selectedOffice : "Lucknow Development Authority",
                        //       selectedDistrict,
                        //       selectedTehsil
                        //     )
                        //   : filterAvpVillagesData(avpVillagesData, selectedDistrict, selectedTehsil);
                        // const tehsils = isDA
                        //   ? filterTehsilData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority", selectedDistrict)
                        //   : filterAvpTehsilData(avpVillagesData, selectedDistrict);
                        return (
                          <tr key={item.id}>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                // data={SortingAlphabatically(
                                //   filterDistrictData(villagesData, isDA ? formData?.selectedOffice : "Lucknow Development Authority")
                                // )}
                                placeholder="Select District"
                                name={`descriptionOfLand.khasraDetails[${index}].district`}
                                type={"textInput"}
                                defaultValue={khasraDetails?.[index]?.district}
                                disabled={isEmployee || isApproved}
                                mandatory
                                isRequired
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                // data={SortingAlphabatically(tehsils)}
                                placeholder="Select Tehsil"
                                name={`descriptionOfLand.khasraDetails[${index}].tehsil`}
                                defaultValue={khasraDetails?.[index]?.tehsil}
                                type={"textInput"}
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                // data={SortingAlphabatically(filteredVillages)}
                                placeholder="Select Village"
                                name={`descriptionOfLand.khasraDetails[${index}].village`}
                                defaultValue={khasraDetails?.[index]?.village}
                                type={"textInput"}
                                maxLength={30}
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                // label=""
                                width={"100%"}
                                hasLabel={false}
                                control={control}
                                placeholder="Enter Plot No./Khasra No./Arazi No."
                                mandatory
                                name={`descriptionOfLand.khasraDetails[${index}].plotNo`}
                                type="specialChar"
                                defaultValue={khasraDetails?.[index]?.plotNo}
                                allowedChars="/,-"
                                maxLength={200}
                                disabled={isEmployee || isApproved}
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            {/* <td style={{ textAlign: "center" }}>
                                      {index > 0 && (
                                        <IconButton onClick={() => removeKhasraDetail(index)} disabled={isEmployee || isApproved}>
                                          <RemoveIcon />
                                        </IconButton>
                                      )}
                                      {index === khasraDetails.length - 1 && (
                                        <IconButton
                                          onClick={() => addKhasraDetail({ plotNo: "", district: "", tehsil: "", village: "" })}
                                          disabled={isEmployee || isApproved}
                                        >
                                          <AddIcon />
                                        </IconButton>
                                      )}
                                    </td> */}
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </TableContainer>
            </fieldset>
          ) : (
            <Row>
              <Col>
                <InputWrapper
                  label="Plot No."
                  control={control}
                  placeholder="Enter Plot No."
                  mandatory={true}
                  defaultValue={formData?.descriptionOfLand?.plotNo}
                  name="descriptionOfLand.plotNo"
                  type="specialChar"
                  allowedChars="/,-"
                  maxLength={200}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Name of Scheme"
                  placeholder="Select Name of Scheme"
                  name={`descriptionOfLand.schemeName`}
                  type={formData?.descriptionOfLand.schemeName || isEmployee || isApproved ? "textInput" : "searchSelect"}
                  maxLength={30}
                  // data={isDA ? SortingAlphabatically(schemeNames) : SortingAlphabatically(avpSchemeNames)}
                  defaultValue={formData?.descriptionOfLand?.schemeName}
                  mandatory
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col>
              <InputWrapper
                label={t("Plot Area (sq.mtr)")}
                control={control}
                placeholder={t("Enter Plot Area")}
                name="descriptionOfLand.landArea"
                mandatory
                maxLength={15}
                defaultValue={formData?.descriptionOfLand?.landArea}
                type="textInput"
                disabled={formData?.plotArea || isEmployee || isApproved}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
              />
            </Col>

            <Col>
              <InputWrapper
                label={t("Activity Proposed")}
                control={control}
                placeholder={t("Select Activity Proposed")}
                name="descriptionOfLand.activityProposed"
                type={formData?.descriptionOfLand?.activityProposed || isEmployee || isApproved ? "textInput" : "searchSelect"}
                // data={SortingAlphabatically(activityProposed)}
                mandatory
                disabled={isEmployee || isApproved}
                maxLength={20}
                validation={{
                  required: {
                    value: true,
                    message: "This field is required",
                  },
                }}
                defaultValue={formData?.descriptionOfLand?.activityProposed}
              />
            </Col>
          </Row>
          <Row>
            {" "}
            <Col>
              <InputWrapper
                label={t("Previous Sanction date")}
                control={control}
                placeholder={t("Enter Previous Sanction date")}
                name="layoutsanctionDate"
                defaultValue={formData?.layoutsanctionDate}
                type="datePicker"
                disabled={isEmployee || isApproved}
              />
            </Col>
            <Col>
              <InputWrapper
                label={t("Application Number")}
                control={control}
                // placeholder={t("Enter File No")}
                name="prevFileNo"
                mandatory
                maxLength={15}
                defaultValue={formData?.prevFileNo}
                type="textInput"
                disabled={isEmployee || isApproved}
              />
            </Col>
          </Row>
          {!isLayoutCase && (
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t(
                    "If it is self-approved, (provide relevant details so that it can be proved that this case is covered under self-approved scheme and prescribed conditions have been duly complied)"
                  )}`}
                  name="completionChecklist.selfApprovedSchemeDetails"
                  defaultValue={formData?.completionChecklist?.completionChecklist?.selfApprovedSchemeDetails}
                  type="radioButton"
                  mandatory
                  disabled={isEmployee || isApproved}
                  data={yesOrNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>{" "}
            </Row>
          )}
          {!isLayoutCase && formData?.internalChanges === "Yes" && (
            <Row>
              <Col>
                <InputWrapper
                  label={t(
                    "Compounding Sanction Number (If compounding of unauthorized construction has been done, then mention the number and date of compounding approval of the map.)"
                  )}
                  control={control}
                  // placeholder={t("Enter File No")}
                  name="prevFileNo"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.prevFileNo}
                  type="textInput"
                />
              </Col>
            </Row>
          )}
        </Container>
      </div>
      {/* <div className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">{t("Challan Details")}</h2>
        </div>{" "}
        <fieldset className="fieldset-wrapper bg-white completion-checklist">
          <TableContainer className="table-container">
            <Table stickyHeader className="application-table landUserTable" border="1" cellPadding="8">
              <thead
                className="table-no-background"
                style={{
                  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                }}
              >
                <tr>
                  <th style={{ width: "5%", textAlign: "center" }}>S.No</th>
                  <th style={{ width: "20%" }}>
                    Date <span className="compulsoryField">*</span>
                  </th>
                  <th style={{ width: "25%" }}>
                    Receipt / Challan No. <span className="compulsoryField">*</span>
                  </th>
                  <th style={{ width: "25%" }}>
                    Name of the Bank <span className="compulsoryField">*</span>
                  </th>
                  <th style={{ width: "15%" }}>
                    Amount (INR) <span className="compulsoryField">*</span>
                  </th>
                  <th style={{ width: "10%", textAlign: "center" }}>Actions</th>
                </tr>
              </thead>

              <tbody>
                {challanDetails?.map((item, index) => (
                  <tr key={item.id}>
                    S.No
                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                    Date
                    <td>
                      <InputWrapper
                        width="100%"
                        hasLabel={false}
                        control={control}
                        label={t("Previous Sanction date")}
                        placeholder={t("Enter Previous Sanction date")}
                        name={`challanDetails[${index}].date`}
                        defaultValue={formData?.layoutsanctionDate}
                        type="datePicker"
                        disabled={isEmployee || isApproved}
                        validation={{
                          required: { value: true, message: "Date is required" },
                        }}
                      />
                    </td>

                    Receipt/Challan No
                    <td>
                      <InputWrapper
                        width="100%"
                        hasLabel={false}
                        control={control}
                        type="textInput"
                        name={`challanDetails[${index}].receiptNo`}
                        placeholder="Enter Receipt/Challan No."
                        defaultValue={item.receiptNo}
                        maxLength={100}
                        disabled={isEmployee || isApproved}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                      />
                    </td>

                    Bank Name
                    <td>
                      <InputWrapper
                        width="100%"
                        hasLabel={false}
                        control={control}
                        type="textInput"
                        name={`challanDetails[${index}].bankName`}
                        placeholder="Enter Bank Name"
                        defaultValue={item.bankName}
                        maxLength={100}
                        disabled={isEmployee || isApproved}
                        validation={{
                          required: { value: true, message: "This field is required" },
                        }}
                      />
                    </td>

                    Amount
                    <td>
                      <InputWrapper
                        width="100%"
                        hasLabel={false}
                        control={control}
                        type="number"
                        name={`challanDetails[${index}].amount`}
                        placeholder="Enter Amount"
                        defaultValue={item.amount}
                        disabled={isEmployee || isApproved}
                        validation={{
                          required: { value: true, message: "Amount is required" },
                          min: { value: 1, message: "Amount must be greater than 0" },
                        }}
                      />
                    </td>

                    Actions
                    <td style={{ textAlign: "center" }}>
                      {index > 0 && (
                        <IconButton onClick={() => removePaymentDetail(index)} disabled={isEmployee || isApproved}>
                          <RemoveIcon />
                        </IconButton>
                      )}
                      {index === challanDetails.length - 1 && (
                        <IconButton onClick={() => addPaymentDetail(emptyPaymentRow)} disabled={isEmployee || isApproved}>
                          <AddIcon />
                        </IconButton>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableContainer>
        </fieldset>
      </div> */}
      {isLayoutCase && (
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Land-Use Details")}</h2>
          </div>
          (
          <fieldset className="fieldset-wrapper bg-white completion-checklist">
            {" "}
            <TableContainer className="table-container">
              <Table stickyHeader border="1" cellPadding="8">
                <thead
                  style={{
                    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th rowSpan="2" style={{ width: "5%", textAlign: "center" }}>
                      S.No
                    </th>

                    <th rowSpan="2" style={{ width: "15%" }}>
                      Land Use Category
                    </th>

                    {/* 2 sub-columns */}
                    <th colSpan="2" style={{ width: "20%", textAlign: "center" }}>
                      As per Approved Plan
                    </th>

                    {/* 2 sub-columns */}
                    <th colSpan="2" style={{ width: "20%", textAlign: "center" }}>
                      Developed
                    </th>

                    {/* 2 sub-columns */}
                    <th colSpan="2" style={{ width: "20%", textAlign: "center" }}>
                      Deviation
                    </th>

                    <th rowSpan="2" style={{ width: "10%", textAlign: "center" }}>
                      Actions
                    </th>
                  </tr>

                  <tr>
                    {/* Approved Plan */}
                    <th>Area (Sq.M.)</th>
                    <th>%</th>

                    {/* Developed */}
                    <th>Area (Sq.M.)</th>
                    <th>%</th>

                    {/* Deviation */}
                    <th>Area (Sq.M.)</th>
                    <th>%</th>
                  </tr>
                </thead>

                <tbody>
                  {landUseDetails?.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>

                      {/* Category */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="textInput"
                          disabled={isEmployee || isApproved || index < 5} // fixed rows cannot edit category
                          name={`landUseDetails[${index}].category`}
                          placeholder="Enter Category"
                          mandatory
                          isRequired
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Approved Area */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].approvedArea`}
                          placeholder="Area"
                          mandatory
                          isRequired
                          disabled={isEmployee || isApproved}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Approved % */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].approvedPercent`}
                          placeholder="%"
                          mandatory
                          isRequired
                          disabled={isEmployee || isApproved}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Developed Area */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].developedArea`}
                          placeholder="Area"
                          mandatory
                          isRequired
                          disabled={isEmployee || isApproved}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Developed % */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].developedPercent`}
                          placeholder="%"
                          mandatory
                          isRequired
                          disabled={isEmployee || isApproved}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Deviation Area */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].deviationArea`}
                          placeholder="Area"
                          mandatory
                          isRequired
                          disabled={isEmployee || isApproved}
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Deviation % */}
                      <td>
                        <InputWrapper
                          control={control}
                          hasLabel={false}
                          type="number"
                          name={`landUseDetails[${index}].deviationPercent`}
                          placeholder="%"
                          mandatory
                          disabled={isEmployee || isApproved}
                          isRequired
                          validation={{
                            required: { value: true, message: "This field is required" },
                          }}
                        />
                      </td>

                      {/* Actions */}
                      <td style={{ textAlign: "center" }}>
                        {index >= 5 && (
                          <IconButton onClick={() => removeRow(index)}>
                            <RemoveIcon />
                          </IconButton>
                        )}

                        {index === landUseDetails.length - 1 && (
                          <IconButton onClick={addRow}>
                            <AddIcon />
                          </IconButton>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableContainer>
          </fieldset>
          )
        </div>
      )}
      {isLayoutCase && (
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Public & Semi-public facilities")}</h2>
          </div>{" "}
          {
            <fieldset className="fieldset-wrapper bg-white completion-checklist">
              {" "}
              <TableContainer className="table-container">
                <Table stickyHeader border="1" cellPadding="8">
                  <thead
                    style={{
                      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                      color: "#fff",
                    }}
                  >
                    <tr>
                      <th rowSpan="2" style={{ width: "5%", textAlign: "center" }}>
                        S.No
                      </th>

                      <th rowSpan="2" style={{ width: "20%" }}>
                        Features
                      </th>

                      {/* 2 columns */}
                      <th colSpan="2" style={{ textAlign: "center" }}>
                        Provisions in Approved Plan
                      </th>

                      {/* 4 columns */}
                      <th colSpan="4" style={{ textAlign: "center" }}>
                        Provisions in Map for Completion
                      </th>

                      <th rowSpan="2" style={{ width: "10%", textAlign: "center" }}>
                        Actions
                      </th>
                    </tr>

                    <tr>
                      {/* Approved Plan */}
                      <th>No.</th>
                      <th>Area (Sq.M.)</th>
                      {/* Completion Map */}
                      <th>No.</th>
                      <th>Area (Sq.M.)</th>
                      <th>No.</th> {/* ← THIS is the extra part you needed */}
                      <th>Area (Sq.M.)</th> {/* ← THIS is the extra part you needed */}
                    </tr>
                  </thead>

                  <tbody>
                    {featureDetails?.map((row, index) => (
                      <tr key={index}>
                        {/* S.No */}
                        <td style={{ textAlign: "center" }}>{index + 1}</td>

                        {/* Feature Name */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="textInput"
                            disabled={isEmployee || isApproved || index < 14} // first 14 fixed, then editable
                            name={`featureDetails[${index}].feature`}
                            placeholder="Enter Feature"
                            mandatory
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Approved Plan: No. */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].approvedNo`}
                            placeholder="No."
                            mandatory
                            isRequired
                            disabled={isEmployee || isApproved}
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Approved Plan: Area */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].approvedArea`}
                            placeholder="Area"
                            mandatory
                            disabled={isEmployee || isApproved}
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Completion Map: No. */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].completionNo`}
                            placeholder="No."
                            mandatory
                            disabled={isEmployee || isApproved}
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Completion Map: Area */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].completionArea`}
                            placeholder="Area"
                            mandatory
                            disabled={isEmployee || isApproved}
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>
                        {/* Completion Map: No. */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].completionNo2`}
                            placeholder="No."
                            mandatory
                            disabled={isEmployee || isApproved}
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Completion Map: Area */}
                        <td>
                          <InputWrapper
                            control={control}
                            hasLabel={false}
                            type="number"
                            name={`featureDetails[${index}].completionArea2`}
                            placeholder="Area"
                            mandatory
                            disabled={isEmployee || isApproved}
                            isRequired
                            validation={{
                              required: { value: true, message: "This field is required" },
                            }}
                          />
                        </td>

                        {/* Actions */}
                        <td style={{ textAlign: "center" }}>
                          {index >= 14 && (
                            <IconButton onClick={() => removeFeatureRow(index)}>
                              <RemoveIcon />
                            </IconButton>
                          )}

                          {index === featureDetails.length - 1 && (
                            <IconButton onClick={addFeatureRow}>
                              <AddIcon />
                            </IconButton>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableContainer>
            </fieldset>
          }
        </div>
      )}
      <div className="formContainer">
        <div className="formHeaderContainer">
          <h2 className="formHeading">{t("Development Standard")}</h2>
        </div>
        {!isLayoutCase && (
          <Container fluid className="formInputContainer common-app-form">
            <fieldset className="fieldset-wrapper bg-white completion-checklist">
              <TableContainer className="table-container">
                <Table striped bordered className="m-0" style={{ margin: "10px", width: "100%", tableLayout: "auto" }}>
                  <thead
                    className="table-no-background"
                    style={{
                      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                      // background: "#f0f0f0"
                    }}
                  >
                    <tr>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>Description</th>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>As per Plan</th>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>On Site</th>
                      <th style={{ whiteSpace: "normal", padding: "10px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span>Remarks</span>

                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={addSetBackRows}
                            size="small"
                            disabled={isEmployee || isApproved}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {facilitiesSetback?.map((field, index) => (
                      <tr key={field.id}>
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            disabled={isEmployee}
                            name={`completionChecklist.facilitiesSetback[${index}].type`}
                            placeholder="Enter Description"
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            disabled={isEmployee}
                            name={`completionChecklist.facilitiesSetback[${index}].asPerPlan`}
                            placeholder="Enter Details"
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            name={`completionChecklist.facilitiesSetback[${index}].onSite`}
                            placeholder="Enter Details"
                            disabled={isCitizen}
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>
                        <td style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          <InputWrapper
                            width={400}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            name={`completionChecklist.facilitiesSetback[${index}].remarks`}
                            placeholder="Enter Remarks"
                            multiline
                            disabled={isCitizen}
                          />
                          {facilitiesSetback?.length > 1 && (
                            <IconButton onClick={() => removeSetbackRow(index)} disabled={isEmployee || isApproved} size="small">
                              <RemoveIcon fontSize="small" />
                            </IconButton>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Table striped bordered className="m-0" style={{ margin: "10px", width: "100%", tableLayout: "auto" }}>
                  <thead
                    className="table-no-background"
                    style={{
                      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
                      // background: "#f0f0f0"
                    }}
                  >
                    <tr>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>Description</th>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>As per Plan</th>
                      <th style={{ whiteSpace: "nowrap", width: "fit-content", borderRight: "2px solid #ccc", padding: "10px" }}>On Site</th>
                      <th style={{ whiteSpace: "normal", padding: "10px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span>Remarks</span>

                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={addBasementRows}
                            size="small"
                            disabled={isEmployee || isApproved}
                          />
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {facilitiesBasement.map((field, index) => (
                      <tr key={field.id}>
                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            disabled={isEmployee}
                            name={`completionChecklist.facilitiesBasement.${index}.type`}
                            placeholder="Enter Details"
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>

                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            name={`completionChecklist.facilitiesBasement.${index}.asPerPlan`}
                            placeholder="Enter Details"
                            disabled={isEmployee}
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>

                        <td>
                          <InputWrapper
                            width={inputWidth}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            name={`completionChecklist.facilitiesBasement.${index}.onSite`}
                            placeholder="Enter Details"
                            disabled={isCitizen}
                            containerStyles={{ width: inputWidth }}
                          />
                        </td>

                        <td style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                          <InputWrapper
                            width={400}
                            hasLabel={false}
                            type="textInput"
                            control={control}
                            name={`completionChecklist.facilitiesBasement.${index}.remarks`}
                            placeholder="Enter Remarks"
                            multiline
                            disabled={isCitizen}
                          />
                          {facilitiesSetback?.length > 1 && (
                            <IconButton onClick={() => removeBasementRow(index)} disabled={isEmployee || isApproved} size="small">
                              <RemoveIcon fontSize="small" />
                            </IconButton>
                          )}
                        </td>

                        {/* Optional remove button */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableContainer>
            </fieldset>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Basement area (sq.mtr)")}
                  control={control}
                  placeholder={t("Enter basement area")}
                  name="completionChecklist.basementArea"
                  // mandatory
                  maxLength={15}
                  defaultValue={formData?.completionChecklist?.completionChecklist?.basementArea}
                  type="textInput"
                  disabled={isEmployee || isApproved}
                  // validation={{
                  //   required: {
                  //     value: true,
                  //     message: "This field is required",
                  //   },
                  // }}
                />
              </Col>
              <Col></Col>
            </Row>

            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Facilities")}`}
                  name="facilities"
                  defaultValue={formData?.facilities}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}

              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Water Supply")}`}
                  name="facilities.waterSupply"
                  defaultValue={formData?.waterSupply}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.waterSupply}
                />
              </Col>
              <Col></Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Sewerage")}`}
                  name="facilities.sewerage"
                  defaultValue={formData?.sewerage}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.sewerage}
                />
              </Col>

              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Drainage")}`}
                  name="facilities.drainage"
                  defaultValue={formData?.drainage}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.drainage}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Power Supply")}`}
                  name="facilities.powerSupply"
                  defaultValue={formData?.powerSupply}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.powerSupply}
                />
              </Col>

              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Rooftop Rainwater Harvesting System")}`}
                  name="facilities.roofTopDrainage"
                  defaultValue={formData?.roofTopDrainage}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.roofTopDrainage}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Solar water heating plant (in plots with area more than 434 sq.m.)")}`}
                  name="facilities.solarPlant"
                  defaultValue={formData?.solarPlant}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  defaultValue={formData?.completionChecklist?.facilities?.solarPlant}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>
        )}

        {isLayoutCase && (
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Roads Provided")}`}
                  name="facilities.roadsProvided"
                  defaultValue={formData?.roadsProvided}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>

              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Roadside tree planting (arboriculture)")}`}
                  name="facilities.roadsideTree"
                  defaultValue={formData?.roadsideTree}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Culvert")}`}
                  name="facilities.culvert"
                  defaultValue={formData?.culvert}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>

              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Street lighting system")}`}
                  name="facilities.lightingSystem"
                  defaultValue={formData?.lightingSystem}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t(
                    "Drinking water distribution system in which sluice valves, air valves, fire hydrants are shown and the diameter of underground water pipes is indicated"
                  )}`}
                  name="facilities.drinkingWater"
                  defaultValue={formData?.drinkingWater}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Location of overhead tanks and underground reservoirs and their capacity, number of pumps and their capacity.")}`}
                  name="facilities.tankLocation"
                  defaultValue={formData?.tankLocation}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Sewer system including diameter of pipes, location of main holes, gully pits giving Invert labels.")}`}
                  name="facilities.sewerSystem"
                  defaultValue={formData?.sewerSystem}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t(
                    "Location of sewage, pumping station, its capacity and number and capacity of pumps (if the said development has been done by the developer)."
                  )}`}
                  name="facilities.sewerLocation"
                  defaultValue={formData?.sewerLocation}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Rainwater drainage system.")}`}
                  name="facilities.rainwaterDrainage"
                  defaultValue={formData?.rainwaterDrainage}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t(
                    "Power supply system indicating the location of transformers and 11 KVA sub-stations and the capacity of transformers."
                  )}`}
                  name="facilities.powerSupplySystem"
                  defaultValue={formData?.powerSupplySystem}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t(
                    "Final discharge of sewer--details of connection with trunk sewer lines of Development Authority/ Housing and Development Board/ Local Body etc."
                  )}`}
                  name="facilities.sewerDischarge"
                  defaultValue={formData?.sewerDischarge}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Ground water recharging system.")}`}
                  name="facilities.groundWater"
                  defaultValue={formData?.groundWater}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Roads connectivity")}`}
                  name="facilities.roadsConnectivity"
                  defaultValue={formData?.roadsConnectivity}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Drainage Provision (connection to trunk drain)")}`}
                  name="facilities.drainageProvision"
                  defaultValue={formData?.drainageProvision}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Arrangement of drinking water (connection arrangement with Jal Sansthan/ Development Authority/ Local Body etc.)")}`}
                  name="facilities.drinkingWaterArrangement"
                  defaultValue={formData?.drinkingWaterArrangement}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Electrical system (status of connection to 33 KVA/11 KVA line and status of transformer)")}`}
                  name="facilities.electricalSystem"
                  defaultValue={formData?.electricalSystem}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Position of connection to sewer/ trunk sewer")}`}
                  name="facilities.sewerConnection"
                  defaultValue={formData?.sewerConnection}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee || isApproved}
                  validation={{
                    required: { value: true, message: "This field is required" },
                  }}
                />
              </Col>
            </Row>
          </Container>
        )}
        {/* {!isEmployee && ( */}
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(2)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
        {/* )} */}
      </div>
    </form>
  );
};

export default CompletionChecklist;
